import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import { FaRegFilePdf } from "react-icons/fa";
import { BiSolidEdit } from "react-icons/bi";
import { MdOutlineFileDownload } from "react-icons/md";

import { useSelector } from "react-redux";
import { getLocalTimeOrFallback } from "../risk_analysis/utils/localDateTime";
import { Button } from "@mui/material";
import FormPageHeader from "../admin/quizSystem/components/FormPageHeader";

const isActualIncident = (item) =>
  Number(item?.training_purpose ?? 0) === 1 &&
  Number(item?.has_read ?? 0) === 0;

// const isTruthyFlag = (value) => {
//   if (value === true) return true;
//   if (value === false || value === null || value === undefined) return false;
//
//   const normalized = String(value).trim().toLowerCase();
//   return normalized === "1" || normalized === "true";
// };
//
// const hasReportingCategoryFlag = (item) =>
//   isTruthyFlag(item?.has_never_miss) ||
//   isTruthyFlag(item?.has_prevention) ||
//   isTruthyFlag(item?.has_doubt_about_reporting);

const getPurposeLabel = (item) => {
  // if (isActualIncident(item) && hasReportingCategoryFlag(item)) {
  //   const categories = [];
  //
  //   if (isTruthyFlag(item?.has_prevention)) categories.push("Prevention");
  //   if (isTruthyFlag(item?.has_never_miss)) categories.push("Near miss");
  //   if (isTruthyFlag(item?.has_doubt_about_reporting)) {
  //     categories.push("Doubt about reporting");
  //   }
  //
  //   return categories.join(", ");
  // }
  //
  // if (isActualIncident(item)) return "Incident (actual)";
  if (isActualIncident(item)) return "Actual incident";
  return "";
};

const AnalysticsDataList = () => {
  const [t] = useTranslation();
  const history = useHistory();
  const [analysticsData, setAnalysticsData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [checkedCheckboxes, setCheckedCheckboxes] = useState([]);
  const jwtToken = localStorage.getItem("jwt_token");
  const id = localStorage.getItem("organisation_id");
  const user_role_id = localStorage.getItem("user_role_id");
  const user_id = localStorage.getItem("user_id");
  const { organizations } = useSelector((state) => state.userOrganizations);
  const isNotExternalInstructor = organizations.some(
    (org) =>
      org.organisation_id === +localStorage.getItem("organisation_id") &&
      org.role != "External Instructor",
  );

  useEffect(() => {
    if (!isNotExternalInstructor) {
      history.replace("/");
    }
  }, [isNotExternalInstructor, history]);

  useEffect(() => {
    const overflowTargets = [
      document.documentElement,
      document.body,
      document.getElementById("root"),
      document.querySelector(".content-wrapper"),
    ].filter(Boolean);

    const previousStyles = overflowTargets.map((element) => ({
      element,
      overflowX: element.style.overflowX,
      maxWidth: element.style.maxWidth,
    }));

    overflowTargets.forEach((element) => {
      element.style.overflowX = "hidden";
      element.style.maxWidth = "100%";
    });

    return () => {
      previousStyles.forEach(({ element, overflowX, maxWidth }) => {
        element.style.overflowX = overflowX;
        element.style.maxWidth = maxWidth;
      });
    };
  }, []);

  const checkAllHandler = () => {
    // Check if all checkboxes are already checked
    const allChecked = analysticsData.every((item) =>
      checkedCheckboxes.includes(item.idnb),
    );

    // If all are checked, uncheck all; otherwise, check all
    const updatedCheckboxes = allChecked
      ? [] // Uncheck all
      : analysticsData.map((item) => item.idnb); // Check all

    setCheckedCheckboxes(updatedCheckboxes);
  };

  const onCheckboxHandler = (id) => {
    // Check if the checkbox is already checked
    const isChecked = checkedCheckboxes.includes(id);

    // Create a copy of the checked checkboxes array
    const updatedCheckboxes = [...checkedCheckboxes];

    // If it's checked, remove it from the list
    if (isChecked) {
      const index = updatedCheckboxes.indexOf(id);
      if (index > -1) {
        updatedCheckboxes.splice(index, 1); // Remove the ID from the array
        setCheckedCheckboxes(updatedCheckboxes);
      }
    } else {
      updatedCheckboxes.push(id); // Add the ID to the array
      setCheckedCheckboxes(updatedCheckboxes);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true); // Start loader
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/ac-analytics/${id}?user_role_id=${user_role_id}&user_id=${user_id}`,
          {
            method: "GET",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: `Bearer ${jwtToken}`,
            },
          },
        );
        const data = await response.json();
        if (response.ok) {
          const apiData = Array.isArray(data.data) ? data.data : [];
          const filteredData = apiData.filter((item) => isActualIncident(item));
          setAnalysticsData(filteredData);
        } else {
          toast.error(data.error);
        }
      } catch (error) {
        toast.error(error.message);
      } finally {
        setLoading(false); // Stop loader
      }
    };

    fetchData();
  }, [id, jwtToken, user_role_id, user_id]);

  const handelclickData = (id) => {
    const jwtToken = localStorage.getItem("jwt_token");
    const organisation_id = localStorage.getItem("organisation_id");
    let url = `${process.env.REACT_APP_API_URL}/ac-analytics?id=${id}&org_id=${organisation_id}`;
    let ids = id;
    if (Array.isArray(id)) {
      if (id.length === 0) {
        toast.error("No report selected.");
        return;
      }
      ids = id.length === 1 ? id[0] : id.join(",");
    }
    fetch(url, {
      method: "get",
      headers: {
        Authorization: `Bearer ${jwtToken}`,
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        const urlLink = data.data;
        // Create an anchor element
        const link = document.createElement("a");
        link.href = urlLink;

        // Set the download attribute and trigger click
        link.setAttribute("download", "filename.ext"); // Specify filename and extension
        link.style.display = "none"; // Hide the link
        document.body.appendChild(link); // Append the link to the document body
        link.click(); // Simulate a click on the link
        document.body.removeChild(link); // Remove the link from the document body after download
      });
  };
  return (
    <div className="admin-page-root min-h-[93vh] overflow-auto bg-white p-3 text-[#20232A] sm:p-4">
      <FormPageHeader title={t("userMenuSidebar.label.AnalysticsData")} />

      <section className="w-full min-w-0 max-w-full overflow-hidden rounded-2xl border border-admin-border bg-white p-4 shadow-admin sm:p-6">
        <div className="mb-5 flex min-w-0 max-w-full flex-col gap-4 min-[1320px]:flex-row min-[1320px]:items-center min-[1320px]:justify-between">
          <div className="flex min-w-0 flex-col gap-2 sm:flex-row sm:flex-wrap min-[1320px]:flex-nowrap min-[1320px]:justify-end">
            <Button
              className="admin-btn w-full sm:w-auto"
              type="button"
              onClick={checkAllHandler}
            >
              <FaRegFilePdf
                className="!text-white"
                aria-hidden="true"
              />
              File All Checkbox
            </Button>

            <Button
              className="admin-btn w-full sm:w-auto"
              type="button"
              onClick={() => handelclickData(checkedCheckboxes)}
            >
              <FaRegFilePdf
                className="!text-white"
                aria-hidden="true"
              />
              Download Selected Reports Data
            </Button>
          </div>

        </div>

        <div className="w-full min-w-0 max-w-full overflow-x-auto rounded-xl border border-admin-border">
          <table className="admin-data-table w-full min-w-[1040px] table-fixed text-center ">
            <thead className="bg-admin-primary !text-white">
              <tr>
                <th
                  className="w-[70px] px-3 py-4 text-center text-[14px] font-semibold !text-white"
                  scope="col"
                >
                  ID
                </th>
                <th
                  className="w-[115px] px-3 py-4 text-center text-[14px] font-semibold !text-white"
                  scope="col"
                >
                  Date
                </th>
                <th
                  className="w-[110px] px-3 py-4 text-center text-[14px] font-semibold !text-white"
                  scope="col"
                >
                  Point in time
                </th>
                <th
                  className="w-[100px] px-3 py-4 text-center text-[14px] font-semibold !text-white"
                  scope="col"
                >
                  Set number
                </th>
                <th
                  className="w-[150px] px-3 py-4 text-center text-[14px] font-semibold !text-white"
                  scope="col"
                >
                  Action card name
                </th>
                <th
                  className="w-[105px] px-3 py-4 text-center text-[14px] font-semibold !text-white"
                  scope="col"
                >
                  Action card id
                </th>
                <th
                  className="w-[115px] px-3 py-4 text-center text-[14px] font-semibold !text-white"
                  scope="col"
                >
                  Purpose
                </th>
                <th
                  className="w-[180px] px-3 py-4 text-center text-[14px] font-semibold !text-white"
                  scope="col"
                >
                  Comment
                </th>
                <th
                  className="w-[140px] px-3 py-4 text-center text-[14px] font-semibold !text-white"
                  scope="col"
                >
                  Employee name
                </th>
                <th
                  className="w-[90px] px-3 py-4 text-center text-[14px] font-semibold !text-white"
                  scope="col"
                >
                  Action
                </th>
                <th
                  className="w-[150px] px-3 py-4 text-center text-[14px] font-semibold !text-white"
                  scope="col"
                >
                  Select Report To Download
                </th>
                <th
                  className="w-[145px] px-3 py-4 text-center text-[14px] font-semibold !text-white"
                  scope="col"
                >
                  Single Report Download
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-admin-border bg-white">
              {loading ? (
                <tr>
                  <td className="px-3 py-8 text-center" colSpan="12">
                    <div className="flex min-h-[90px] items-center justify-center">
                      <div
                        className="h-8 w-8 animate-spin rounded-full border-4 border-admin-border border-t-admin-primary"
                        role="status"
                      >
                        <span className="sr-only">Loading...</span>
                      </div>
                    </div>
                  </td>
                </tr>
              ) : analysticsData.length === 0 ? (
                <tr>
                  <td className="px-3 py-8 text-center" colSpan="12">
                    <div className="flex min-h-[90px] items-center justify-center text-[14px] font-medium text-admin-muted">
                      Data Not Found
                    </div>
                  </td>
                </tr>
              ) : (
                analysticsData.map((item, i) => {
                  const resultString = getPurposeLabel(item);
                  return (
                    <tr
                      className="min-h-[92px] align-middle odd:bg-white even:bg-[#FAFAFA] transition hover:bg-[#FFF1F1]"
                      key={item.idnb}
                    >
                      <th
                        className="px-3 py-8 text-center text-[14px] font-medium text-admin-text"
                        scope="row"
                      >
                        {item.idnb}
                      </th>
                      <td className="px-3 py-8 text-center text-[14px] font-semibold text-black">
                        {item.utc_tid_skannet.split(" ")[0]}
                      </td>
                      <td className="px-3 py-8 text-center text-[14px] text-admin-text">
                        {getLocalTimeOrFallback(
                          item.utc_tid_skannet,
                          item.utc_tid_skannet,
                        ) || "-"}
                      </td>
                      <td className="px-3 py-8 text-center text-[14px] font-semibold text-black">
                        {item.nb_set}
                      </td>
                      <td className="px-3 py-8 text-center text-[14px] text-admin-text">
                        {item.action_card_name}
                      </td>
                      <td className="px-3 py-8 text-center text-[14px] font-semibold text-black">
                        {item.action_card_number}
                      </td>
                      <td className="px-3 py-8 text-center text-[14px] text-admin-text">
                        {resultString}
                      </td>
                      <td className="break-words px-3 py-8 text-center text-[14px] text-admin-text">
                        {item.comments}
                      </td>
                      <td className="px-3 py-8 text-center text-[14px] text-admin-text">
                        {item.employee}
                      </td>
                      <td className="px-3 py-8 text-center">
                        <button
                          type="button"
                          className="inline-flex h-9 w-9 items-center justify-center rounded-md !border !border-admin-primary bg-admin-primary !text-white transition hover:bg-admin-primary-hover focus:outline-none focus:ring-2 focus:ring-admin-primary focus:ring-offset-2"
                          aria-label={`Edit report ${item.idnb}`}
                          onClick={() => {
                            history.push({
                              pathname: `/analystics/update`,
                              search: `?id=${item.idnb}`,
                              state: { rowData: item },
                            });
                          }}
                        >
                          <BiSolidEdit
                            className="!text-white"
                            aria-hidden="true"
                            size={30}
                          />
                        </button>
                      </td>
                      <td className="px-3 py-8 text-center">
                        <div className="flex items-center justify-center">
                          <input
                            className="h-4 w-4 cursor-pointer rounded border-admin-border accent-admin-primary"
                            type="checkbox"
                            id={`checkbox-${item.idnb}`}
                            checked={checkedCheckboxes.includes(item.idnb)}
                            onChange={() => onCheckboxHandler(item.idnb)}
                          />
                          <label
                            className="sr-only"
                            htmlFor={`checkbox-${item.idnb}`}
                          >
                            Select report {item.idnb} to download
                          </label>
                        </div>
                      </td>
                      <td className="px-3 py-8 text-center">
                        <button
                          type="button"
                          className="inline-flex h-9 w-9 items-center justify-center rounded-md !border !border-admin-primary bg-admin-primary !text-white transition hover:bg-admin-primary-hover focus:outline-none focus:ring-2 focus:ring-admin-primary focus:ring-offset-2"
                          aria-label={`Download report ${item.idnb}`}
                          onClick={() => handelclickData(item.idnb)}
                        >
                          <MdOutlineFileDownload
                            className="!text-white"
                            aria-hidden="true"
                            size={30}
                          />
                        </button>
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );
};
export default AnalysticsDataList;
